module.exports = {"name":"one-item","component":"PolicyNumber","validator":[{"name":"required"},{"name":"propertyPolicyNumber"}]};